import { Injectable } from '@angular/core';
import { Shop } from '@app/_models';
import { Observable, ReplaySubject } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ShopService {

  private shopListEndpoint = "B2C/Shop/List";

  private shops: ReplaySubject<Shop[]>;
  public shops$: Observable<Shop[]>;

  constructor(
    private baseService: BaseService
  ) { 
    this.shops = new ReplaySubject<Shop[]>(1)
    this.shops.next([]);
    this.shops$ = this.shops.asObservable();
  }

  public refreshList() {
    return this.baseService.getOnce<Shop[]>(this.shopListEndpoint, (data: Shop[]) => {
      this.shops.next(data);
    });
  }

}
